import React, { useState, useEffect } from "react";
import { AiOutlineClose, AiFillEdit } from "react-icons/ai";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { ImCross } from "react-icons/im";
import { AllChurchHooks } from "../../screens/Churches/hooks/Churchhooks";
import GalleryPickerField from "../ImageGallery/GalleryPickerField";

import {
  saveGiveSettingRequest,
  updateGiveSettingRequest,
  deleteGiveSettingRequest,
} from "../../store/GiveSetting/giveSettingActions";

const GiveSettingField = ({ church }) => {
  const dispatch = useDispatch();
  const churchObjId = church?._id;
  const { fetchAllChurches } = AllChurchHooks();

  const [fetchedChurch, setFetchedChurch] = useState(null);

  const [giveURL, setGiveURL] = useState("");
  const [selectedGalleryObjId, setSelectedGalleryObjId] = useState(null);
  const [selectedGallery, setSelectedGallery] = useState({});
  const [editingItem, setEditingItem] = useState(null);

  const [resetTrigger, setResetTrigger] = useState(0);

  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  // ------------------------------------------------
  // FETCH latest data (after ADD, EDIT, DELETE)
  // ------------------------------------------------
  const refetchChurch = () => {
    if (!churchObjId) return;

    fetchAllChurches(
      1,
      9999,
      {},
      (res) => {
        if (res?.data?.length) {
          setFetchedChurch(res.data[0]);
        }
      },
      churchObjId
    );
  };

  useEffect(() => {
    refetchChurch();
  }, [churchObjId]);

  // ------------------------------------------------
  // HANDLE GALLERY PICK
  // ------------------------------------------------
  const resetForm = () => {
    setGiveURL("");
    setSelectedGalleryObjId(null);
    setSelectedGallery({});
    setEditingItem(null);
    setResetTrigger((p) => p + 1);
  };

  const handleGalleryPick = (e) => {
    const arr = e?.target?.value;
    // if (!arr?.length) return toast.error("Invalid image");

    setSelectedGallery(arr);

    const selected = arr[0]; // first image

    const imgUrl =
      selected?.web?.url ||
      selected?.tablet?.url ||
      selected?.mobile?.url ||
      selected?.imageUrl ||
      selected?.url ||
      "";

    const gid =
      selected?._id ||
      selected?.id ||
      selected?.galleryObjId ||
      selected?.coverimageObjId ||
      null;

    // setGiveURL(imgUrl);
    setSelectedGalleryObjId(gid);
  };


  // ------------------------------------------------
  // SAVE / UPDATE
  // ------------------------------------------------
  const handleSaveSettings = () => {
    const finalURL = giveURL.trim();
    if (!finalURL) return toast.error("Enter URL or pick image");
     if (!editingItem && !selectedGallery?.length)
        return toast.error("Pick image first");


    // ===================
    // UPDATE MODE
    // ===================
    if (editingItem) {
      const payload = {
        _id: churchObjId,
        giveObjId: editingItem.giveObjId,
        giveurl: finalURL,
        galleryObjId: selectedGalleryObjId || editingItem.galleryObjId,
        mobilesetting: editingItem.mobilesetting,
        tabletsetting: editingItem.tabletsetting,
        dashboardsetting: editingItem.dashboardsetting,
        default: editingItem.default ? "true" : "false",
      };

      return dispatch(
        updateGiveSettingRequest(payload, (res) => {
          if (res?.type === 1) {
            // toast.success("Updated!");
            resetForm();
            refetchChurch(); // *** IMPORTANT ***
          } else toast.error(res?.error || "Update failed");
        })
      );
    }

    // ===================
    // ADD NEW (multiple images)
    // ===================
    const arr = selectedGallery
;
    let done = 0;
    let failed = false;

    arr.forEach((img) => {
      const payload = {
        _id: churchObjId,
        giveurl: finalURL,
        galleryObjId: img.id || img._id || img.galleryObjId,
        mobilesetting: img.mobilesetting || "contain",
        tabletsetting: img.tabletsetting || "contain",
        dashboardsetting: img.dashboardsetting || "contain",
        default: img.default ? "true" : "false",
      };

      dispatch(
        saveGiveSettingRequest(payload, (res) => {
          done++;
          if (!res || res.type !== 1) failed = true;

          if (done === arr.length) {
            if (failed) toast.error("Some failed");

            resetForm();
            refetchChurch(); // *** REFRESH LIST ***
          }
        })
      );
    });
  };

  // ------------------------------------------------
  // DELETE
  // ------------------------------------------------
  const handleDelete = (item) => {
    dispatch(
      deleteGiveSettingRequest(
        { _id: churchObjId, giveObjId: item.giveObjId },
        (res) => {
          if (res?.type === 1) {
            // toast.success("Deleted");
            refetchChurch(); // refresh list
          } else toast.error(res?.error || "Delete failed");
        }
      )
    );
  };

  // ------------------------------------------------
  // EDIT
  // ------------------------------------------------
  const handleEdit = (item) => {
    setEditingItem(item);
    setGiveURL(item.giveurl);
    setSelectedGalleryObjId(item.galleryObjId);

    handleGalleryPick({
      target: {
        value: [
          {
            id: item.gallery?._id || item.galleryObjId,
            imageUrl: item.gallery?.imageUrl,
            imageName: item.gallery?.imageName,
            mobilesetting: item.mobilesetting,
            tabletsetting: item.tabletsetting,
            dashboardsetting: item.dashboardsetting,
          }
        ]
      }
    });

    window.scrollTo({ top: 0, behavior: "smooth" });
  };



  // ------------------------------------------------
  // PREVIEW
  // ------------------------------------------------
  const openPreview = (item) => {
    setSelectedImage(item);
    setShowModal(true);
  };

  // ------------------------------------------------
  // RENDER
  // ------------------------------------------------
  return (
    <>
    {
      church?
    <div className="px-4 text-white">

      {/* URL FIELD */}
      <div className="flex justify-end items-center mb-3">
        <button
          onClick={handleSaveSettings}
          className="text-yellowish border border-yellowish rounded-xl py-2 px-6 text-[12px] font-medium transition-all duration-200"
        >
               {editingItem ? "Update Give Setting" : "Save Give Setting"}

        </button>
      </div>
      <div className="mb-4">
        <label className="text-[12px] text-greyish font-medium leading-4">
          Giving URL
        </label>
        <input
          type="text"
          placeholder="Enter Giving URL"
          className="bg-blackish p-2 w-full text-white text-[14px] mt-2 rounded-md h-10"
          value={giveURL}
          onChange={(e) => setGiveURL(e.target.value)}
        />
      </div>

      {/* GALLERY PICKER */}
      <GalleryPickerField
        label="Pick Give Thumbnail"
        name="giveImage"
        church={church}
        handleChange={handleGalleryPick}
        autoSave={false}
        resetTrigger={resetTrigger}
        rowData={editingItem}       // *** IMPORTANT ***
      />

      {/* SAVE / UPDATE BUTTON */}
        {/* <button
            onClick={handleSaveSettings}
            className="mt-4 px-6 py-2 bg-yellowish text-black rounded-md"
        >
            {editingItem ? "Update Give Setting" : "Save Give Setting"}
        </button> */}

      <hr className="my-6 border-gray-700" />

      {/* LIST */}
      {fetchedChurch?.givesettings?.length > 0 && (
        <div className="flex flex-wrap gap-8 mt-6">
          {fetchedChurch.givesettings.map((gs) => (
            <div key={gs.giveObjId} className="relative group">

              <img
                src={gs.gallery?.imageUrl}
                className="w-[180px] h-[120px] object-cover rounded-lg border border-gray-700 shadow-md cursor-pointer"
                onClick={() => openPreview(gs)}
              />

              {/* LABEL */}
              <div className="absolute bottom-2 left-1/2 -translate-x-1/2 bg-black/70 text-[10px] px-2 py-0.5 rounded-md text-center w-[90%]">
                <div>{gs.gallery?.imageName}</div>
                <div className="text-[8px] text-gray-300 truncate">{gs.giveurl}</div>
              </div>

              {/* EDIT */}
              <div className="absolute bottom-2 left-2 bg-black/50 p-1 rounded-full cursor-pointer">
                <AiFillEdit
                  className="text-white w-4 h-4"
                  onClick={() => handleEdit(gs)}
                />
              </div>

              {/* DELETE */}
              <div className="absolute top-2 left-2 bg-black/50 p-1 rounded-full cursor-pointer">
                <AiOutlineClose
                  className="text-white w-4 h-4"
                  onClick={() => handleDelete(gs)}
                />
              </div>
            </div>
          ))}
        </div>
      )}

      {/* MODAL */}
      {showModal && selectedImage && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[200]">
          <div className="bg-gray-900 p-6 rounded-lg relative">
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-4 right-4 bg-black/60 p-2 rounded-full"
            >
              <ImCross className="text-white" />
            </button>

            <img
              src={selectedImage.gallery.imageUrl}
              className="max-w-[80vw] max-h-[75vh] object-contain"
            />
          </div>
        </div>
      )}
    </div>
    :
    <div className="w-full h-full flex items-center justify-center text-gray-400 ">
       <p>Add Church/Ministry/Channel First</p>

    </div>
}
    </>
  );
};

export default GiveSettingField;
